import { NormalLayout } from './NormalLayout';
export default NormalLayout;
